import * as yup from 'yup';

export const categoriesIncomes = [
  'part time job',
  'main salary',
  'rental income',
  'offside project',
];
export const categoriesExpenses = [
  'house/garden',
  'car',
  'travel',
  'bills',
  'shopping',
  'music',
  'sport',
];

export const currencyOptions = {
  style: 'currency',
  currency: 'PLN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export const schema = yup.object().shape({
  type: yup.string('Select expense or income').required('Required').oneOf(
    ['expense','income'],
    'Must be a valid type'
  ),
  title: yup.string('Set title of new item').required('Required'),
  amount: yup
    .number('Set amount of money (must be positive)')
    .positive()
    .required('Required'),
  category: yup
    .string()
    .typeError('You must specify a valid number')
    .oneOf(
      [...categoriesIncomes, ...categoriesExpenses],
      'Must be a valid category'
    )
    .required('Required'),
});
